import HTTP from '@/utils/http';

const defaultState = () => ({
  branding: {
    colour: '#0098ce',
    colour_accent: null,
    colours: {},
    logo: null,
    logo_alternate: null,
    is_customised: false,
  },
  previewEmail: null,
});

const brandingModule = {
  namespaced: true,
  state: defaultState(),
  mutations: {
    RESET_STATE(state) {
      Object.assign(state, defaultState());
    },
    SET(state, { result }) {
      state.branding = result;
    },
    SET_PREVIEW_EMAIL(state, { result }) {
      state.previewEmail = result;
    },
  },
  actions: {
    RESET_STATE({ commit }) {
      commit('RESET_STATE');
    },
    GET({ commit }) {
      return HTTP({
        url: 'branding',
      }).then((response) => {
        commit('SET', {
          result: response.data.data,
        });
      });
    },
    PREVIEW_EMAIL({ commit }) {
      return HTTP({
        url: 'branding/email-preview',
      }).then(
        response => commit('SET_PREVIEW_EMAIL', {
          result: response.data.data,
        }),
        () => commit('SET_PREVIEW_EMAIL', {
          result: null,
        }),
      );
    },
    UPDATE({ commit }, data) {
      return HTTP({
        method: 'PUT',
        url: 'branding',
        data,
      }).then((response) => {
        commit('SET', {
          result: response.data.data,
        });
      });
    },

    UPDATE_FILE({ commit }, update) {
      const formData = new FormData();
      Object.keys(update).forEach(key => formData.append(key, update[key]));

      return HTTP({
        contentType: 'multipart/form-data',
        method: 'POST',
        url: 'branding',
        data: formData,
      }).then((response) => {
        commit('SET', {
          result: response.data.data,
        });
      });
    },
  },

  getters: {
    isCustomised: state => state.branding.is_customised,
    getBranding: state => state.branding,
    previewEmail: state => state.previewEmail,
  },
};

export default brandingModule;

/** @typedef {RefRT<typeof import('@/store/modules/branding').default.getters>} Getters */
